class VariantButton extends HTMLElement {
  /**
   * Constructs a new instance of the VariantButton class.
   */
  constructor() {
    super();

    /*-------------------------- INITIALIZE DATA -----------------------------------*/

    const parseAttribute = (attribute) => {
      return JSON.parse(
        attribute
          .replace(/'/g, '"')
      );
    };

    // Get the primary product info
    this.productInfo = parseAttribute(this.getAttribute("js-product"));
    // Get the variants
    this.variants = parseAttribute(this.getAttribute("js-variants"));
    // Get the first available variant, this is required to determine which option is selected on default load
    this.firstAvailableVariant = parseAttribute(
      this.getAttribute("js-first-available-variant")
    );

    //Initialize on variant change event when the variant button is clicked
    this.addEventListener("click", this.onVariantChange);
  }
  async connectedCallback() {
    try {
      //Render the variant options on load
      this.renderOptions();
    } catch (err) {
      console.error("Error fetching product data:", err);
    }
  }

  /**
   * Renders the options for the variant button.
   */
  renderOptions() {
    let html = `
        <div class="flex flex-col my-4">`;

    //based on the first selected option, load the variants
    this.selectedVariants = this.variants.filter((variant) => {
      return variant.option1 == this.firstAvailableVariant[0].option1;
    });

    //If there's atleast 1 or more set of product options then execute the logic below
    if (
      this.productInfo.options.length >= 1 &&
      this.productInfo.options[0].values.length > 1
    ) {

      //render first drop down
      html += `
      <div class="flex justify-between items-center">
        <label for="${this.productInfo.options[0].name}" class="option-name">${this.productInfo.options[0].name}: <span>${this.firstAvailableVariant[0].option1.replaceAll('/quote/', '"').replaceAll('/apos/', '\'')}</span></label>
      </div>`;
      html += `<fieldset class="flex flex-wrap" id="${this.productInfo.options[0].name}">`;

      //if only one set of options, render the first level of variants directly, if variant is sold then disable option
      if (this.productInfo.options.length == 1) {
        this.variants.forEach((variant) => {
          //if first available variant is the same as the variant, then check it
          html += this.renderLabel(
            variant.title,
            "select-option1",
            variant.available,
            this.productInfo.options[0].name == "Color",
            this.firstAvailableVariant[0].option1 == variant.title
          );
        });
      } else {
        //if variant has more than one set of options, then don't disable the first level of options
        this.productInfo.options[0].values.forEach((value) => {
          html += this.renderLabel(
            value,
            "select-option1",
            true,
            this.productInfo.options[0].name == "Color",
            this.firstAvailableVariant[0].option1 == value
          );
        });
      }
      html += `</fieldset>`;
    }

    if (this.productInfo.options.length > 1) {
      //render second drop down
      html += `
      <div class="flex justify-between items-center">
        <label for="${this.productInfo.options[1].name}" class="option-name">${this.productInfo.options[1].name}: <span>${this.firstAvailableVariant[1].option2.replaceAll('/quote/', '"').replaceAll('/apos/', '\'')}</span></label>
      </div>`;
      html += `<fieldset class="flex flex-wrap" id="${this.productInfo.options[1].name}">`;
      //loads the option based on the first selected variant

      if (this.productInfo.options.length == 2) {
        // render only unique variants
        this.returnUniqueVariants(2).forEach((variant) => {
          if (variant.option2 != null) {
            // check if variant already exists in array
            html += this.renderLabel(
              variant.option2,
              "select-option2",
              variant.available,
              this.productInfo.options[1].name == "Color",
              this.firstAvailableVariant[1].option2 == variant.option2
            );
          }
        });
      } else {
        //if variant has more than two set of options, then don't disable the second level of options
        this.returnUniqueVariants(2).forEach((variant) => {
          if (variant.option2 != null) {
            // check if variant already exists in array
            html += this.renderLabel(
              variant.option2,
              "select-option2",
              true,
              this.productInfo.options[1].name == "Color",
              this.firstAvailableVariant[1].option2 == variant.option2
            );
          }
        });
      }

      html += `</fieldset>`;
    }

    if (this.productInfo.options.length > 2) {
      //render third drop down

      html += `
        <div class="flex justify-between items-center">
        <label for="${this.productInfo.options[2].name}" class="option-name">${this.productInfo.options[2].name}: <span>${this.firstAvailableVariant[2].option3.replaceAll('/quote/', '"').replaceAll('/apos/', '\'')}</span></label>
        </div>`;
      html += `<fieldset class="flex flex-wrap" id="${this.productInfo.options[2].name}">`;
      //loads the option based on the second selected variant

      this.returnUniqueVariants(3).forEach((variant) => {
        if (variant.option3 != null) {
          html += this.renderLabel(
            variant.option3,
            "select-option3",
            variant.available,
            this.productInfo.options[2].name == "Color",
            this.firstAvailableVariant[2].option3 == variant.option3
          );
        }
      });
      html += `</fieldset>`;
    }

    html += `</div>`;
    if (this.productInfo.available == false) {
      document.querySelector(".product__cta").disabled = true;
      document.querySelector(".product__cta").innerHTML = `Sold Out`;
    }

    this.insertAdjacentHTML("beforeend", html);
  }

  /**
   * Handles the change event for the variant selection.
   * @param {Event} e - The change event object.
   */
  onVariantChange(e) {

    this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = this.fieldsets.map((fieldset) => {
      const checkedRadio = Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      );
      return checkedRadio ? checkedRadio.value : null;
    });

    this.options.forEach((option, index) => {
      if(document.querySelectorAll('.option-name span')[index] && option){
        document.querySelectorAll('.option-name span')[index].innerText = option.replaceAll('/quote/', '"').replaceAll('/apos/', '\'')
      }
    })
    /*--------------------------Event ---------------------------------------*/
    //if the change is on the first set of options
    this.onFirstLevelOfOptionsChange(e);

    /*--------------------------Event ---------------------------------------*/
    //if the change is on the second set of options
    this.onSecondLevelOfOptionsChange(e);

    /*--------------------------Event ---------------------------------------*/
    //get current variant from option changes
    this.getCurrentVariant();
  }

  /**
   * Handles the change event on the first level of options.
   *
   * @param {Event} e - The event object.
   */
  onFirstLevelOfOptionsChange(e) {
    //if the change is on the first select dropdown
    if (e.target.name == "select-option1") {
      //only works if variant.option2 is available
      let options = this.fieldsets[1] ? this.fieldsets[1] : null;
      //reset options on update
      this.selectedVariants = this.variants.filter((variant) => {
        return variant.option1 == this.options[0];
      });

      if (this.productInfo.options.length > 1) {
        let html = "";
        //assign second set of options

        //if there are three levels of options, do not disable any of the second level options
        if (this.productInfo.options.length > 2) {
          this.returnUniqueVariants(2).forEach((variant) => {
            html += this.renderLabel(
              variant.option2,
              "select-option2",
              true,
              this.productInfo.options[1].name == "Color",
              this.options[1] == variant.option2
            );
          });
        } else {
          //otherwise, disable the second level options if the variant is not available
          this.returnUniqueVariants(2).forEach((variant) => {
            html += this.renderLabel(
              variant.option2,
              "select-option2",
              variant.available,
              this.productInfo.options[1].name == "Color",
              this.options[1] == variant.option2
            );
          });
        }

        options.innerHTML = "";

        options.insertAdjacentHTML("beforeend", html);
      }

      if (this.productInfo.options.length > 2) {
        //assign third set of options
        let options2 = this.fieldsets[2] ? this.fieldsets[2] : null;

        let html = "";
        this.selectedVariants = this.variants.filter((variant) => {
          return (
            variant.option2 == this.options[1] &&
            variant.option1 == this.options[0]
          );
        });
        this.returnUniqueVariants(3).forEach((variant) => {
          html += this.renderLabel(
            variant.option3,
            "select-option3",
            variant.available,
            this.productInfo.options[2].name == "Color",
            this.options[2] == variant.option3
          );

          options2.innerHTML = "";

          options2.insertAdjacentHTML("beforeend", html);
        });
      }
    }
  }

  /**
   * Handles the change event on the second level of options.
   * @param {Event} e - The event object.
   */
  onSecondLevelOfOptionsChange(e) {
    if (e.target.name == "select-option2") {
      //only works if variant.option2 is available
      let options = this.fieldsets[2] ? this.fieldsets[2] : null;
      //reset options on update
      this.selectedVariants = this.variants.filter((variant) => {
        return (
          variant.option2 == this.options[1] &&
          variant.option1 == this.options[0]
        );
      });

      //assign third set of options
      if (this.productInfo.options.length > 2) {
        let html = "";

        this.returnUniqueVariants(3).forEach((variant) => {
          if (variant.option3 != null) {
            html += this.renderLabel(
              variant.option3,
              "select-option3",
              variant.available,
              this.productInfo.options[2].name == "Color",
              this.options[2] == variant.option3
            );
          }
          options.innerHTML = "";

          options.insertAdjacentHTML("beforeend", html);
        });
      }
    }
  }

  /**
   * Retrieves the current variant based on the selected options.
   * If the current variant doesn't exist, it updates the product cta and disables it.
   * If the current variant is available, it updates the product cta and enables it.
   * It also updates the price, gallery image, and sets the data-variant attribute.
   */
  getCurrentVariant() {
    //get current variant from selected options
    this.currentVariant = this.variants.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    //bug function, if current variant doesn't exist, but both options are selected then rerun
    if (!this.currentVariant) {
      document.querySelector(
        ".product__cta"
      ).innerHTML = `<span class="text-[20px]">Select Option
    </span>`;
      document.querySelector(".product__cta").classList.add("cursor-");
      document.querySelector(".product__cta").disabled = true;
    }

    if (this.currentVariant) {
      if (this.currentVariant.available == false) {
        document.querySelector(".product__cta").disabled = true;
        document.querySelector(
          ".product__cta"
        ).innerHTML = `<span class="text-[20px] opacity-50">Sold Out
      </span>`;
      } else {
        //update price on variant change
        document.querySelector(".product__cta").disabled = false;
        document.querySelector(
          ".product__cta"
        ).innerHTML = `<span class="text-[20px]">Add to cart
    </span>`;

        document.querySelector("buy-button").id = this.currentVariant.id;
        this.setAttribute("data-variant", this.currentVariant.id);
        if (this.currentVariant?.price) {
          document.querySelector(".product__main-price").innerText = `${
            this.currentVariant?.symbol
          }${(this.currentVariant?.price / 100).toFixed(2)} ${
            this.currentVariant?.currency
          }`;
        }
        //update gallery image on variant change
        if (this.currentVariant.featured_image != null) {
          const changeSlider = new CustomEvent("changeSlider", {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: {
              media_id: this.currentVariant.featured_image,
            },
          });

          document.dispatchEvent(changeSlider);
        }
      }
    }
  }

  /**
   * Returns an array of unique variants based on the specified option index.
   * @param {number} optionIndex - The index of the option to filter variants by.
   * @returns {Array} - An array of unique variants.
   */
  //This function is to return unique variant options, so that the options are not duplicated
  returnUniqueVariants(optionIndex) {
    const uniqueVariants = [];
    this.selectedVariants.forEach((variant) => {
      if (variant[`option${optionIndex}`] != null) {
        const exists = uniqueVariants.some(
          (v) => v[`option${optionIndex}`] === variant[`option${optionIndex}`]
        );
        if (!exists) {
          uniqueVariants.push(variant);
        }
      }
    });
    return uniqueVariants;
  }

  /**
   * Renders the label for a variant button.
   *
   * @param {string} variantOption - The variant option.
   * @param {string} selectOption - The select option.
   * @param {boolean} isInStock - Indicates if the variant is in stock.
   * @param {boolean} isColor - Indicates if the variant is a color.
   * @param {boolean} checked - Indicates if the variant is checked.
   * @returns {string} The rendered label HTML.
   */
  //This function renders the button input and label
  renderLabel(variantOption, selectOption, isInStock, isColor, checked) {
    let soldOutDisabled = isInStock == false ? "disabled" : "";
    let soldOutStyle = isInStock == false ? "sold-out" : "";
    let isChecked = checked == true ? "checked" : "";
    let swatchStyle = isColor
      ? `swatch swatch-${variantOption.toLowerCase().replaceAll(' ', '-')} mr-5 mt-1.5`
      : `button-primary button-swatch mr-2`;
    let labelContent = "";
    if (isColor && isInStock == false) {
      labelContent = `<div  class="absolute inset-0 flex items-center"><div class="w-full border-t-2 border-black transform rotate-45 h-[2px] bg-[#E6E6E6]" style="transform: rotate(135deg);"></div></div>`;
    } else if (isColor && isInStock == true) {
      labelContent = "";
    } else {
      labelContent = variantOption;
    }

    return `<input ${isChecked} ${soldOutDisabled} class="product__variant--button hidden" name="${selectOption}" id="option-${variantOption}" type="radio" value="${variantOption}"><label class="${swatchStyle} ${soldOutStyle}" for="option-${variantOption}">
    ${labelContent.replaceAll('/quote/', '"').replaceAll('/apos/', '\'')}
      </label>`;
  }
}
customElements.define("variant-button", VariantButton);


class BuyButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.addToCart);
  }

  addToCart(e) {
    e.preventDefault(); // Prevent any default behavior

    const self = this;
    self.classList.add('opacity-80');

    // Get the form element
    const form = this.closest('form');
    const formData = new FormData(form);

    // Convert FormData to JSON, including subscription data (e.g., selling_plan)
    const items = {
      id: this.id, // Variant ID from buy-button element
      quantity: formData.get('quantity') || 1,
    };

    // Include subscription selling plan if present
    if (formData.get('selling_plan')) {
      items.selling_plan = formData.get('selling_plan');
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [items],
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }
        return response.json();
      })
      .then((data) => {
        let sidecart = document.querySelector('side-cart');
        sidecart?.openCart();
        self.classList.remove('opacity-80');
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);
        self.classList.remove('opacity-80');
        // Optionally show an error message to the user
      });
  }
}

customElements.define('buy-button', BuyButton);


class ProductPayments extends HTMLElement {
  constructor() {
    super()

    document.querySelectorAll('.payments-modal-trigger').forEach(function(btn) {
      btn.addEventListener('click', function() {
        let id = btn.dataset.id
        if(document.getElementById(id)) {
          document.getElementById(id).classList.remove('!hidden')
          document.body.classList.add('overflow-hidden')
        }
      })
    })

    document.querySelectorAll('.close-modal').forEach(function(btn) {
      btn.addEventListener('click', function() {
        document.querySelectorAll('.payments-modal').forEach(item => item.classList.add('!hidden'))
        document.body.classList.remove('overflow-hidden')
      })
    })
    
  }
}

customElements.define('product-payments', ProductPayments)


if(document.querySelector('.loop-widget-container')) {
  document.querySelector('.loop-widget-container').addEventListener('click', function() {
    let price = document.querySelector('.loop-widget-purchase-option-selected .loop-widget-purchase-option-price').innerHTML
    if(price) {
      document.querySelector('.product__main-price').innerHTML = price
    }
  })
}